import React, { Component } from 'react';

class Work extends Component {
  render() {

    if(this.props.data){
      var work = this.props.data.projects.map(function(work){
        var workImage = 'images/portfolio/'+work.image;
        return <div key={work.title}><h3><span style={{color:'blue'}}>{work.title}</span></h3>
            <img alt={work.title} src={workImage} />
            <p className="info">{work.role}<span>&bull;</span> <em className="date">{work.years}</em></p>
            <p>{work.description}</p>
        </div>
      })
    }

    return (
      <section id="work">

     <div className="row work">

         <div className="three columns header-col">
            <h1><span>Work</span></h1>
         </div>

         <div className="nine columns main-col">
          {work}
        </div>

         <div className="three columns header-col">
            <h1><span>Worked Consensus Mechanism</span></h1>
         </div>

         <div className="nine columns main-col">
          <img alt="consensus" src="images/portfolio/Consensus.png" />
        </div>
    </div>
   </section>
    );
  }
}

export default Work;



// WEBPACK FOOTER //
// ./src/Components/Work.js